import React, { Component } from 'react';
import { Modal,
    Alert,
    FormGroup,
    ControlLabel,
    FormControl,
    OverlayTrigger,
    Tooltip,
} from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import Validation from 'react-validation';

// To handle requests
import AccountsAPI from '../utils/AccountsAPI';
import {
    passwordValidator,
    passwordConfirmationValidator,
    validatePasswordFields,
    getPasswordValidationState,
    PASSWORD_MIN_LENGTH,
    PASSWORD_MAX_LENGTH
} from '../utils/passwordValidation';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';

import { namespace } from '../../../config.json';

class SetPasswordAccountComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            modalErrorAlert: '',
            password: '',
            confirmationPassword: '',
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitPassword = this.submitPassword.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            showModal: false,
            modalErrorAlert: '',
            password: '',
            confirmationPassword: '',
            credentials: null,
        });
    }


    // Handle text input change to update state
    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    // Fired when form is submitted
    submitPassword(e) {
        e.preventDefault();

        // Validate password fields
        const validation = validatePasswordFields(
            this.state.password,
            this.state.confirmationPassword
        );

        if (!validation.isValid) {
            this.setState({
                modalErrorAlert: validation.errors[0],
            });
            return;
        }

        this.setState({ modalErrorAlert: '' });

        AccountsAPI.generateCredentialsForAccount(
          this.props.username,
          this.state.password,
          window.location.hostname).then(res => {
              this.setState({
                  credentials: res.credentials,
                  password: '',
                  confirmationPassword: '',
              });
              if (this.props.callback) {
                  // Small timeout so the user can see the success message
                  setTimeout(() => {
                      this.props.callback();
                  }, 1500);
              }
          }).catch(message => {
              if (message.status === 401 || message.status === 403) {
                  window.location.href =
                    `${namespace}/login/error/${message.status}`;
              } else if (message.status === 409) {
                  this.setState({
                      modalErrorAlert: `Account "${this.state.username}" already
                                        exists.`,
                  });
              } else if (message.status === 400) {
                  this.setState({
                      modalErrorAlert: `Unable to create account.
                                Please verify that the username is valid.`,
                  });
              } else {
                  this.setState({
                      modalErrorAlert: `Unable to process the request as the
                                       server returned an Internal Error.`,
                  });
              }
          }
        );
    }

    render() {
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger">
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        const successAlert = <Alert bsStyle="success">
          <strong>Success</strong>
          <br />
          Password has been set
        </Alert>;

        const form = (
          <div>
            <Validation.components.Form>

                <div className="form-group">
                  <FormGroup
                    controlId="formValidationError2"
                    validationState={
                      getPasswordValidationState(
                        this.state.password,
                        passwordValidator
                      )
                    }>
                    <ControlLabel>
                      <i
                        className="fa fa-lock"
                        style={brandingStyles.mainColor}
                      />
                    &nbsp;New password
                    </ControlLabel>
                    <Validation.components.Input
                        className="form-control"
                        style={brandingStyles.backgrounds.input}
                        type="password"
                        value={this.state.password}
                        onChange={this.handleChange}
                        placeholder={`Password (${PASSWORD_MIN_LENGTH}-${PASSWORD_MAX_LENGTH} characters)`}
                        name="password"
                        validations={['required',
                            'validPassword',
                        ]}/>
                    <FormControl.Feedback />
                  </FormGroup>
                </div>

                <div className="form-group">
                  <FormGroup
                    controlId="formValidationError2"
                    validationState={
                      getPasswordValidationState(
                        this.state.confirmationPassword,
                        (password) => passwordConfirmationValidator(this.state.password, password)
                      )
                    }>
                    <ControlLabel>
                      <i
                        className="fa fa-lock"
                        style={brandingStyles.mainColor}
                      />
                      &nbsp;Password confirmation
                    </ControlLabel>
                    <Validation.components.Input
                        className="form-control"
                        style={brandingStyles.backgrounds.input}
                        type="password"
                        value={this.state.confirmationPassword}
                        onChange={this.handleChange}
                        placeholder="Confirm Password"
                        name="confirmationPassword"
                        validations={['required',
                            'validPassword',
                            'validPasswordConfirmation',
                        ]}/>
                    <FormControl.Feedback />
                  </FormGroup>
                </div>

                {errorAlert}
                <Validation.components.Button
                  onClick={this.submitPassword}
                  style={brandingStyles.buttons.primary}
                  className="btn btn-primary pull-right"
                >
                  Submit
                </Validation.components.Button>

            </Validation.components.Form>
            <div style={{
                clear: 'both',
            }}></div>
          </div>
        );

        const buttonTooltip = (
          <Tooltip id="tooltip">
            {'Set account password'}
          </Tooltip>
        );


        return (
          <OverlayTrigger
            placement="top"
            overlay={buttonTooltip}
          >
              <button
                className="btn btn-primary btn-xs set-password-btn"
                style={brandingStyles.buttons.primary}
                onClick={this.openModal}>
                <i className="fa fa-lock" />

                  <Modal show={this.state.showModal} onHide={this.closeModal}>
                      <Modal.Header
                        style={brandingStyles.backgrounds.panelHeader}
                      >
                          <Modal.Title
                            style={brandingStyles.backgrounds.panelHeader}
                          >
                              <i
                                className="fa fa-lock"
                                style={brandingStyles.mainColor}
                              ></i>
                              <span>&nbsp;</span>
                              {'Set account password'}
                              <i
                                  className="fa fa-times pull-right clickable"
                                  style={Object.assign(
                                    { marginTop: '3px' },
                                    brandingStyles.mainColor
                                  )}
                                  onClick={this.closeModal}
                              ></i>
                          </Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={brandingStyles.backgrounds.panel}>
                        {this.state.credentials ? successAlert : form}
                      </Modal.Body>
                  </Modal>

              </button>
            </OverlayTrigger>
        );
    }

}

SetPasswordAccountComponent.propTypes = {
    username: PropTypes.string,
    callback: PropTypes.func,
};

export default SetPasswordAccountComponent;



/** WEBPACK FOOTER **
 ** ./src/components/SetPasswordAccountButton.js
 **/